<template>
    <CalendarRoot v-slot="{ weekDays, grid }" v-bind="{ ...$attrs, ...props }" class="calendar rounded-lg p-4 border" fixed-weeks>
        <CalendarHeader class="flex items-center justify-between">
            <CalendarPrev class="nav inline-flex items-center cursor-pointer rounded-md w-6 justify-center data-disabled:pointer-events-none data-disabled:opacity-75">
                <i class="bi bi-chevron-left icon-semibold" aria-hidden="true"></i>
            </CalendarPrev>
            <CalendarHeading class="body" />
            <CalendarNext class="nav inline-flex items-center cursor-pointer rounded-md w-6 justify-center data-disabled:pointer-events-none data-disabled:opacity-75">
                <i class="bi bi-chevron-right icon-semibold" aria-hidden="true"></i>
            </CalendarNext>
        </CalendarHeader>
        <div class="flex flex-col space-y-4 pt-4 sm:flex-row sm:space-x-4 sm:space-y-0">
            <CalendarGrid v-for="month in grid" :key="month.value.toString()" class="w-full border-collapse select-none space-y-1">
                <CalendarGridHead>
                    <CalendarGridRow class="mb-1 grid w-full grid-cols-7">
                        <CalendarHeadCell v-for="day in weekDays" :key="day" class="weekday rounded-md body-small-bold">
                            {{ day }}
                        </CalendarHeadCell>
                    </CalendarGridRow>
                </CalendarGridHead>
                <CalendarGridBody class="grid">
                    <CalendarGridRow v-for="(weekDates, index) in month.rows" :key="`weekDate-${index}`" class="grid w-full grid-cols-7">
                        <CalendarCell v-for="weekDate in weekDates" :key="weekDate.toString()" :date="weekDate" class="relative text-center mx-auto body-small">
                            <CalendarCellTrigger
                                :day="weekDate"
                                :month="month.value"
                                class="day cursor-pointer relative flex items-center justify-center rounded-full whitespace-nowrap body-small font-normal w-8 h-8 data-disabled:pointer-events-none data-disabled:line-through before:absolute before:top-1.25 before:hidden before:rounded-full before:w-1 before:h-1 data-today:before:block" />
                        </CalendarCell>
                    </CalendarGridRow>
                </CalendarGridBody>
            </CalendarGrid>
        </div>
    </CalendarRoot>
</template>
<script setup lang="ts">
import {
    CalendarCell,
    CalendarCellTrigger,
    CalendarGrid,
    CalendarGridBody,
    CalendarGridHead,
    CalendarGridRow,
    CalendarHeadCell,
    CalendarHeader,
    CalendarHeading,
    CalendarNext,
    CalendarPrev,
    CalendarRoot,
    type CalendarRootProps,
} from "reka-ui";

const props = defineProps<CalendarRootProps>();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .calendar {
        @apply bg-calendar-bg border-calendar-border;
    }

    .nav {
        @apply hover:bg-calendar-nav-hover-bg;
    }

    .weekday {
        @apply text-ink-muted;
    }

    /* Variant order mirrors the utility cascade the trigger had: disabled and
       outside-view mute the day, selected wins over both, and the today dot
       flips to the selected text colour on the selected day. */
    .day {
        @apply text-calendar-day-text data-disabled:text-calendar-day-muted-text data-outside-view:text-calendar-day-muted-text data-selected:bg-calendar-day-selected-bg data-selected:text-calendar-day-selected-text before:bg-calendar-today-dot-selected data-today:before:bg-calendar-today-dot data-selected:data-today:before:bg-calendar-today-dot-selected;
    }
}
</style>
